import { Box } from '../../../ui/primitives'
import { SecondaryLinks } from './SecondaryLinks'
import { Container } from '../Container'

export const AffiliateFooter = () => {
	return (
		<Box backgroundColor={'legacy.darkerPurple'} paddingY={'xxl'}>
			<Container>
				<SecondaryLinks />
			</Container>
		</Box>
	)
}
